// extracted by mini-css-extract-plugin
module.exports = {"paper":"a4-1of1-qr-40x40_paper__20UQC","page":"a4-1of1-qr-40x40_page__yxluV","container_qr_code":"a4-1of1-qr-40x40_container_qr_code__1gp49"};